<template>

  <div>
    <el-dialog title="签退人员" :visible.sync="dialogVisible" width="70%" @close="closeDialog">
      <div class="check-out-container">
        <!-- <div class="header-actions">
          <el-button type="primary" icon="el-icon-plus" size="small" @click="addCheckOut">添加签退</el-button>
        </div> -->

        <el-table size="small" :data="checkOutList" border style="width: 100%" v-loading="loading">
          <el-table-column prop="employee_name" label="员工姓名" width="120"></el-table-column>
          <el-table-column prop="employee_phone" label="手机号" width="130"></el-table-column>
          <el-table-column prop="check_out_time" label="签退时间" width="160"></el-table-column>
          <el-table-column prop="remark" label="备注" width="200" show-overflow-tooltip></el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="deleteCheckOut(scope.row)" type="text" size="small" style="color: #f56c6c;">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog title="添加签退" :visible.sync="addDialogVisible" width="40%" @close="closeAddDialog">
      <el-form :model="checkOutForm" label-width="100px" size="small" ref="checkOutForm">
        <el-form-item label="员工姓名" prop="employee_id">
          <el-select v-model="checkOutForm.employee_id" placeholder="请选择员工" filterable>
            <el-option v-for="item in employeeList" :key="item.ma_employee_id" :label="item.name" :value="item.ma_employee_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="checkOutForm.employee_phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="checkOutForm.remark" :rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAddDialog">取消</el-button>
        <el-button type="primary" @click="submitAdd">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Ma_new_meetingApi from '@/api/ma_new_meeting.js';

export default {
  props: ['open_check_out', 'ma_new_meeting_id'],
  data() {
    return {
      dialogVisible: false,
      addDialogVisible: false,
      loading: false,
      checkOutList: [],
      employeeList: [],
      checkOutForm: {
        employee_id: '',
        employee_phone: '',
        remark: ''
      }
    };
  },
  watch: {
    open_check_out: {
      handler(val) {
        if (val) {
          this.dialogVisible = true;
          this.loadCheckOutList();
          this.loadEmployeeList();
        } else {
          this.dialogVisible = false;
        }
      },
      immediate: true
    }
  },
  methods: {
    loadCheckOutList() {
      let self = this;
      self.loading = true;
      Ma_new_meetingApi.getCheckOutList({ ma_new_meeting_id: self.ma_new_meeting_id }, true)
          .then(data => {
            self.loading = false;
            if (data.code === 1) {
              self.checkOutList = data.data.list || [];
            }
          })
          .catch(error => {
            self.loading = false;
          });
    },

    loadEmployeeList() {
      let self = this;
      Ma_new_meetingApi.getEmployeeList({}, true)
          .then(data => {
            if (data.code === 1) {
              self.employeeList = data.data.list || [];
            }
          })
          .catch(error => {
          });
    },

    addCheckOut() {
      this.checkOutForm = {
        employee_id: '',
        employee_phone: '',
        remark: ''
      };
      this.addDialogVisible = true;
    },

    submitAdd() {
      let self = this;
      if (!self.checkOutForm.employee_id) {
        self.$message.warning('请选择员工');
        return;
      }

      let params = {
        ma_new_meeting_id: self.ma_new_meeting_id,
        ...self.checkOutForm
      };

      self.loading = true;
      Ma_new_meetingApi.addCheckOut(params, true)
          .then(data => {
            self.loading = false;
            if (data.code === 1) {
              self.$message.success('签退成功');
              self.addDialogVisible = false;
              self.loadCheckOutList();
            } else {
              self.$message.error(data.msg || '签退失败');
            }
          })
          .catch(error => {
            self.loading = false;
          });
    },

    deleteCheckOut(row) {
      let self = this;
      self
          .$confirm('确定要删除这条签退记录吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Ma_new_meetingApi.deleteCheckOut({ id: row.id }, true)
                .then(data => {
                  if (data.code === 1) {
                    self.$message.success('删除成功');
                    self.loadCheckOutList();
                  } else {
                    self.$message.error('删除失败');
                  }
                })
                .catch(error => {
                });
          })
          .catch(() => {
          });
    },

    closeDialog() {
      this.$emit('close');
    },

    closeAddDialog() {
      this.addDialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.check-out-container {
  padding: 20px;
}

.header-actions {
  margin-bottom: 20px;
  text-align: right;
}

.dialog-footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_new_meeting/index/part/CheckOutPerson.vue